import React from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import NavBar from "../layout/NavBar";
import LabReimbursementCartsTable from './LabReimbursementCartsTable';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import CreateCartForAHCReimbursement from '../ExceptionalReimbursement/modals/CreateCartForAHCReimbursement';

const LabReimbursementCarts = () => {
    
    const [createCartForAHCReimbursementModal, setCreateCartForAHCReimbursementModal] = React.useState(false);

    const toggleCreateCartModal = () => {
        setCreateCartForAHCReimbursementModal(!createCartForAHCReimbursementModal);
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <NavBar />
            </div>
            <div className="row mt-5 pt-1">
                <div className="col-4">
                    <h2 className="pl-1">Carts for Reimbursement</h2>
                </div>
                <div className="col-4">
                    <button className="btn btn-primary mt-1" onClick={toggleCreateCartModal}>Create Cart for AHC Reimbursement</button>
                </div>
            </div>
            <LabReimbursementCartsTable />
            {
                createCartForAHCReimbursementModal &&
                <CreateCartForAHCReimbursement
                    isOpen={createCartForAHCReimbursementModal}
                    header="Create Cart for AHC Reimbursement"
                    onClose={toggleCreateCartModal}
                    className="bg-info"
                    showExceptionalReimbursement={true}
                />
            }
        </div>
    );
}
const mapStateToProps = (state) => {
    return {};
}

export default withRouter(connect(
    mapStateToProps,
)(LabReimbursementCarts));